<template>
    <b-skeleton-wrapper class="mt-2" :loading="loading">
        <template #loading>
            <slot name="prepend-content"></slot>
            <b-card v-if="spinner" class="text-center">
                <b-spinner variant="primary"></b-spinner>
            </b-card>
            <b-card v-else>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-card>
        </template>
        <b-list-group v-if="(showEmpty || itemList.length > 0)">
            <slot name="prepend-content"></slot>
            <b-list-group-item
                v-if="errorMessage.length > 0"
                variant="danger"
            >
                <font-awesome-icon icon="exclamation-triangle" class="mr-2"></font-awesome-icon>
                {{ errorMessage }}
            </b-list-group-item>
            <template v-for="(item, idx) in itemList">
                <b-list-group-item
                    v-if="!item.removed && !not.includes(item.id)"
                    :key="idx"
                >
                    <slot name="content" :item="item" :refresh="loadItems"></slot>
                    <div class="text-center">
                        <slot name="actions" :item="item" :refresh="loadItems"></slot>
                        <div
                            class="sc-tooltip"
                            v-if="deleteUrl && ((typeof canDelete == 'boolean' && canDelete) || (typeof canDelete == 'function' && canDelete(item)))"
                        >
                            <b-button
                                @click="confirmDelete(item)"
                                variant="link"
                            >
                                <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                            </b-button>
                            <span class="tooltiptext">Remove</span>
                        </div>
                    </div>
                </b-list-group-item>
            </template>
            <slot v-if="itemList.length == 0" name="empty">
                <b-list-group-item  variant="info">
                    <font-awesome-icon icon="info-circle" class="mr-2"></font-awesome-icon> {{ emptyText }}
                </b-list-group-item>
            </slot>
            <slot name="append-content"></slot>
        </b-list-group>
    </b-skeleton-wrapper>
</template>
<script>
const strformat = (str, item) => {
    return str.replace(/\{([a-z_]+)\}/g, (_, key) => item[key]);
};

export default {
    props: {
        listSrc:   Promise,
        listUrl:   String,
        deleteUrl: String,
        items:     { type: Array,   default: () => []  },
        itemsKey:  { type: String,  default: "records" },
        spinner:   { type: Boolean, default: false     },
        not:       { type: Array,   default: () => []  },
        canDelete: { type: [Function, Boolean], default: true },
        showEmpty: { type: Boolean, default: true },
        emptyText: { type: String,  default: "No items to display." }
        //classList:
    },
    data() {
        return {
            loading : false,
            itemList: [...this.items],
            errorMessage: ""
        };
    },
    mounted() {
        if (this.listUrl || this.listSrc)
            this.loadItems();
        else
            this.$emit("loaded", this.itemList);
    },
    methods: {
        loadItems() {
            //console.log("LOAD");
            // Clear the array
            this.itemList.splice(0, this.itemList.length);

            // Set loading state
            this.loading = true;

            // Load the new items
            var listSrc = (this.listSrc) ? this.listSrc : this.$api.get(this.listUrl);
            listSrc.then(({ data }) => {
                console.log(data);
                if (data.success == false) {
                    this.errorMessage = data.message || "An unknown error occurred.";
                }
                else {
                    this.itemList = data[this.itemsKey];
                    this.$emit("loaded", this.itemList);
                }
                this.loading  = false;
            });
        },
        confirmDelete(item) {
            this.$bvModal.msgBoxConfirm("Please confirm that you want to delete '" + (item.title || item.name) + ".'", {
                title           : "Please Confirm",
                size            : "sm",
                buttonSize      : "sm",
                okVariant       : "danger",
                okTitle         : "Delete",
                cancelTitle     : "Cancel",
                footerClass     : "p-2",
                hideHeaderClose : false,
                centered        : true
            })
            .then(deleteConfirmed => {
                if (deleteConfirmed)
                    this.deleteItem(item);
            })
            .catch(err => {
                console.log("Error:", err);
            });
        },
        deleteItem(item) {
            this.$api.post(
                strformat(this.deleteUrl, item),
                item
            ).then(({ data })=> {
                this.$bvToast.toast(data.message, {
                    title           : "Notification",
                    variant         : (data.success) ? "success" : "danger",
                    autoHideDelay   : 5000,
                    appendToast     : true
                });
                this.loadItems();
            });
        },
    }
}
</script>